// Stable data-testid values for the P7-B admin screens (bell, notification centre, settings).
export const NTF_TID = {
  bellBadge: "notifications-bell-badge",
  bellList: "notifications-bell-list",
  bellViewAll: "notifications-bell-view-all",
  centrePage: "notifications-centre-page",
  centreItem: (id: string) => `notification-${id}`,
  markAllRead: "notifications-mark-all-read",
  liveState: "notifications-live-state",
  settingsPage: "notification-settings-page",
  prefs: "notification-prefs",
  prefToggle: (event: string, channel: string) => `pref-${event}-${channel}`,
  prefsSave: "notification-prefs-save",
  push: "notification-push",
  pushToggle: "notification-push-toggle",
  templates: "notification-templates",
  templateEdit: (event: string, channel: string) => `template-${event}-${channel}`,
  templatePreview: "notification-template-preview",
  senders: "notification-senders",
  aliases: "notification-aliases",
} as const;
